import React, { useEffect } from "react";


import "../EDC/EDC.css";
  

import {
  vision,
  mission_data,
  edc_logo,
} from "../../constants/edc";

import { Deptvision, Deptmission, Underline } from "../../widgets";

const EDC = () => {
  useEffect(() => {
    document.title = "ACCET-EDC";
  }, []);
  return (
    <div>
      <div className="edc_underline">
        <Underline heading="Aim" />
      </div>
      <div className="edc_flex">
        <p className="edc_cont">
          To create an advanced platform for students to transform innovative
          ideas into viable business strategies, while cultivating
          entrepreneurial thinking, leadership skills, and problem-solving
          abilities. The EDC is committed to guiding students from the
          conception of an idea to its successful execution, providing
          mentorship, resources, and exposure to the entrepreneurial ecosystem.
          By encouraging interdisciplinary collaboration, the Cell enables
          students from various domains to come together, exchange perspectives,
          and build impactful solutions. The club encourages interdisciplinary collaboration, allowing students
        from various fields of study to come together and work on projects. This
        fosters diversity of thought and enriches the learning experience.
        </p>
        <div className="edc_img_holder">
          <img className="edc_img" src={edc_logo} alt="edc_image" />
        </div>
      </div>
      <div className="edc_obj">
        <p>
          <b>Staff in charge:</b> Dr.D.Helena Margaret ASP/ECE
          <br />
          <b>Student president:</b> Rhamprassath K Final year EEE
        </p>
      </div>
      {/* <p className="edc_cont2">
        The club encourages interdisciplinary collaboration, allowing students
        from various fields of study to come together and work on projects. This
        fosters diversity of thought and enriches the learning experience.
      </p> */}
      <div className="edc_underline">
        <Underline heading="Vision & Mission" />
      </div>
      <div className="edc_vis">
        <Deptvision visiondata={vision.visiondata} />
        <Deptmission points={mission_data} />
      </div>

      <div className="edc_underline">
        <Underline heading="Objective" />
      </div>

      <div className="edc_obj">
        <p>To foster entrepreneurial skills through training programs, workshops, and expert talks.</p>
      </div>
      <div className="edc_obj1">
        <p>To guide students through the complete entrepreneurial process: ideation, validation, planning, execution, scaling, and closure.</p>
      </div>
      <div className="edc_obj">
        <p>To connect students with mentors, industry professionals, and investors for strategic guidance.</p>
      </div>
      <div className="edc_obj1">
        <p>To encourage participation in competitions like the National Entrepreneurship Challenge by E-Cell, IIT Bombay, and other innovation challenges.</p>
      </div>
      <div className="edc_obj">
        <p>To facilitate access to incubation, funding, and prototype development resources.</p>
      </div>
    </div>
  );
};

export default EDC;
